import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);

const CONTENT_X = "-100vw";
const DURATION_SLOW = DURATION * 1.5;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function initTextpage(section) {
  const content = section.querySelector(".textpage__content");

  if (!content) {
    return;
  }

  if (reducedMotion) {
    gsap.set(content, { x: 0, opacity: 1 });
    section.classList.add("is-in-view");
    return;
  }

  gsap.set(content, { x: CONTENT_X, opacity: 0 });

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      gsap.to(content, {
        x: 0,
        opacity: 1,
        duration: DURATION_SLOW,
        ease: EASE,
      });
    },
  });
}

document.querySelectorAll(".textpage").forEach(initTextpage);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
